import { Phone, Mail, Send } from 'lucide-react';
import { CONTACT } from '@/lib/contact';

const ContactPage = () => (
  <div className="container-pd py-16 max-w-3xl" data-testid="contact-page">
    <div className="font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-[0.2em]">Get in touch</div>
    <h1 className="font-display text-5xl leading-none mt-3">Contact.</h1>
    <p className="mt-4 text-muted-sage">
      Weekdays, 9–5. Email replies within one working day.
    </p>

    <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
      <a
        href={CONTACT.phoneHref}
        className="bg-surface border border-pd rounded-2xl p-5 hover:border-[color:var(--pd-accent-yellow)] transition-colors"
        data-testid="contact-phone"
      >
        <div className="flex items-center gap-2 font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-widest">
          <Phone size={14} /> Phone
        </div>
        <div className="mt-3 font-display text-2xl leading-tight text-[color:var(--pd-text)]">
          {CONTACT.phoneDisplay}
        </div>
        <p className="mt-2 text-xs text-muted-sage">Weekdays 9–5. Tap to call.</p>
      </a>

      <a
        href={CONTACT.emailHref}
        className="bg-surface border border-pd rounded-2xl p-5 hover:border-[color:var(--pd-accent-yellow)] transition-colors"
        data-testid="contact-email"
      >
        <div className="flex items-center gap-2 font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-widest">
          <Mail size={14} /> Email
        </div>
        <div className="mt-3 font-display text-xl leading-tight text-[color:var(--pd-text)] break-all">
          {CONTACT.email}
        </div>
        <p className="mt-2 text-xs text-muted-sage">Replies within one working day.</p>
      </a>

      <div className="bg-surface border border-pd rounded-2xl p-5" data-testid="contact-postal">
        <div className="flex items-center gap-2 font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-widest">
          <Send size={14} /> Free postal entries
        </div>
        <div className="mt-3 font-mono text-sm leading-relaxed text-[color:var(--pd-text)]">
          {CONTACT.postalAddressLines.map((l) => (
            <div key={l}>{l}</div>
          ))}
        </div>
        <p className="mt-2 text-xs text-muted-sage">Postal competition entries only. See clause 4 of the T&amp;Cs for the format.</p>
      </div>
    </div>

    <p className="mt-10 text-xs text-muted-sage">
      Registered company details are in the site footer.
    </p>
  </div>
);

export default ContactPage;
